import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { getIdByTag, tagDictionary } from '../data/TagDictionary';
import { tagGroups } from '../data/TagGroups';

const tags = Object.keys(tagDictionary).map(id => ({
  label: tagDictionary[id as unknown as keyof typeof tagDictionary],
  id,
}));

const tagGroupsIds = tagGroups.map(tagGroup => ({
  label: tagGroup.group,
  ids: tagGroup.tags.map(tag => String(getIdByTag(tag))),
}));

export default function TagsFilter(props: {
  tagIdsChanged: (value: null | string[]) => void;
  isAdmin: boolean;
}) {
  return props.isAdmin ? (
    <Autocomplete
      disablePortal
      options={tags}
      onChange={(e, value) => props.tagIdsChanged(value ? [value.id] : null)}
      sx={{ width: 300 }}
      renderInput={params => <TextField {...params} label="Tag"/>}
    />
  ) : (
    <Autocomplete
      disablePortal
      options={tagGroupsIds}
      onChange={(e, value) => props.tagIdsChanged(value ? value.ids : null)}
      sx={{ width: 300 }}
      renderInput={params => <TextField {...params} label="Tag"/>}
    />
  );
}
